import PropTypes from "prop-types";
import React, { Component, createRef } from "react";
import {
  FixedWidth,
  DisplayFlex,
  BlurContainer,
  BlurOverlay, 
  StyleLessButton,
  PagesHeading
} from "../../../../CommonComponents/commonStyles";
import Preloader from "../../../../CommonComponents/Preloader/Preloader";
import { Row, Col } from "antd";
import RadioTableComponent from "../../Components/Table/RadioTable";
import { myProfileDataSuccess } from "../../actions";
import { EditButtonComponent, CSREditButtonComponent } from "../../../../CommonComponents/CTA/Buttons";
import WebAccess from "../../Components/WebAccess/WebAccess";
import ContactDetails from "../../Components/ContactDetails/ContactDetails";
import UserDetails from "../../Components/UserDetails/UserDetails";
import PrintComponents from "react-print-components";
import printIcon from "../../../../assets/icons/print.svg";

import exportIcon from "../../../../assets/icons/export.svg";
import { initiateTracking } from '../../../../utils/commonUtil';
import {
  BlockContainer, 
  ProfileSectionHeading,
  HorizontalDivider,
  IconPadding, 
  DataExportPrint
} from "../../styles";
import { showComponent, hideComponent } from "../../actions";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import RadioCardComponent from "../../Components/MyProfileCard/RadioCard";
import { getPrimaryAccount, getAccountData, isGeminiUser } from "../../../../utils/sessionUtil";
import BreadcrumbComponent from "../../../../CommonComponents/Breadcrumb/Breadcrumb";
import MyProfilePrint from "./myProfilePrint";
import WebRegisterComponent from "../../../../CSR/WebAccessContainer/WebRegisterComponent/WebRegisterComponent";
import _ from "lodash";
import { selectHeader } from "../../../../actions/globalActions";
import { ContentProvider, Types, ContentMessage } from "../../../../CommonComponents/ContentMessages";
import { exportExcelTableData } from "../../../../services/apiServices";
import { myProfileDerivedStates } from "../../selectors";
import { CapsuleButton } from "../../../../CommonComponents/Commons/commonComponents";
import MessageBox from "../../../../CommonComponents/Messages";

const TableComponent = React.lazy(() => import('../../Components/Table/Table'));
const CardComponent = React.lazy(() => import('../../Components/MyProfileCard/Card'));

class MyProfile extends Component {

  constructor(props){
    super(props);
    this.pageTitle = "My Profile";
    this.acctInfoTitle = "Account Information";
    this.tableComponent = createRef();
    this.state = {
      modalVisible: false,
      isBlurDisabled: true,
      fromCsrUser: false,
      accTableSortedInfo: null,
      accTablExtraInfo: null
    };   
  }

  componentDidMount() {  
    this.props.hideComponent();
    window.scrollTo(0, 0);
    this.props.myProfileData({
      metaData: [{
          method: "GET",
          url: 
        `/donor-portal/api/profile/${getPrimaryAccount().userId}/getAccountProfileByAccountIdAndPartyId?partyId=${getAccountData().partyId}`,
          page: "myProfile"
      },{
        method: "GET",
        url: "/donor-portal/api/dropDownValues/getCodeValueMapping",
        page: "myProfile"
      }]
    });
  }



  setPageTitle = (title='') => {
    if(title) {
      this.pageTitle = title;
    }
  }

  setAcctInfoTitle = (title = "") => {
    if(title) {
      this.acctInfoTitle = title;
    }
  }

  getPageTitle = () => {
    return this.pageTitle;
  }

  getAcctInfoTitle = () => {
    return this.acctInfoTitle;
  }



  analyticsTracking(event, action, label) {    
    initiateTracking(event, this.getPageTitle(), action, label);
  }

  toggleisEnabled = value => {
    this.setState({ isBlurDisabled: value });
  };



  viewComponent = () => {
    this.analyticsTracking('edit', this.getAcctInfoTitle(), 'Edit');
    this.props.showComponent();
    this.toggleisEnabled(false);
    this.updateFromCsr(false)
  };

  viewComponentByCSRUser = (value) => {
    this.props.showComponent();
    this.toggleisEnabled(false);
    this.updateFromCsr(value)
  }

  updateFromCsr = (value) => {
    this.setState({ fromCsrUser: value })
  }



  exportAccountInfoDetails = ({sorter, extra}) => {
    this.setState({
      accTableSortedInfo: sorter,
      accTablExtraInfo: extra
    })
  }

  exportAccountsTable = () => {
    const { accTablExtraInfo } = this.state;
    const { profileData } = this.props;
    let url = `/donor-portal/api/profile/${getAccountData().partyId}/exportAccountInformation`;
    let params = accTablExtraInfo ? accTablExtraInfo.currentDataSource : profileData.accountInformations;
    const filename = 'Account Information.xlsx';
    return exportExcelTableData(url, params, filename)
  }

  render() {
    const ref = createRef();    
    const { isLoadingProfile, profileData, countries,accessKeyData,accessKeyExpiry} = this.props;
    //Added by Nixon - For CSR User check
    let userData = JSON.parse(sessionStorage.getItem('userData'));
    const geminiUser = isGeminiUser();
    const isAdminUser = userData?userData.csrUser:null;
    //-/Nixon
    if (isLoadingProfile) return <Preloader data-test="myProfileLoader"/>;
    this.breadcrumbRoutes = () => {
      return [
        {
          routeName: "Home",
          path: "/"
        },
        {
          routeName: () => <ContentMessage type={[Types.SUB_HEADING_LEGACY_OPTIONS]} page="My Profile" property="field_page_title" defaultMessage="My Profile" />,
          path: ""
        }
      ];
    };

    const PrintText = props => {      
      return(
        <DataExportPrint><a  onClick={() => this.analyticsTracking('print', '', props.children)}>{props.children}</a></DataExportPrint>
      )
    }

    // Check Not web register
    const checkNotWebregister = () => _.isNull(profileData.webAccess)
    const checkLegacyRegister = () => {
      return !_.isNull(profileData.webAccess) && !_.isNull(profileData.webAccess.webRegistered) && !profileData.webAccess.webRegistered
    }

    return (
      <ContentProvider types={[Types.SUB_HEADING_LEGACY_OPTIONS]} pages={["My Profile"]} data-test="myProfileSection">
        <div>
          <FixedWidth>
            <BreadcrumbComponent breadcrumbRoutes={this.breadcrumbRoutes()} />
            <Row>
              <PagesHeading>
                <ContentMessage type={[Types.SUB_HEADING_LEGACY_OPTIONS]} page="My Profile" property="field_page_title" defaultMessage="My Profile" setTitle={this.setPageTitle} />
              </PagesHeading>  
              <MessageBox/>
            </Row>
            <Row className="DisplayPflex">
              <Col lg={12} md={12} sm={24} xs={24}>
                <UserDetails
                profileData={profileData}
                isLoading={this.props.isLoading}
              />
              </Col>
              <Col lg={12} md={12} sm={24} xs={24}>
                <div className='right-align'>
                  <PrintComponents
                    className="i_print"
                    trigger={
                      <StyleLessButton>
                        <IconPadding> 
                          <img src={printIcon} alt="Print ico"/>
                          <PrintText>PRINT</PrintText>
                        </IconPadding>
                      </StyleLessButton>
                    }
                  >
                    <MyProfilePrint profileData={profileData} accessKeyData={accessKeyData} accessKeyExpiry={accessKeyExpiry} />
                  </PrintComponents>
                </div>
              </Col>
            </Row>
            <BlurContainer ref={ref}>
              <BlurOverlay isEnabled={this.state.isBlurDisabled} />
              <BlockContainer>
                <ContactDetails analyticsTracking={ (e, a, l) => this.analyticsTracking(e, a, l)} profileData={profileData} countries={countries} />
              </BlockContainer>
              <BlockContainer>
                { isGeminiUser() && checkNotWebregister() || checkLegacyRegister() ? <WebRegisterComponent profileData={profileData}/> :
                  <WebAccess analyticsTracking={ (e, a, l) => this.analyticsTracking(e, a, l)} profileData={profileData} />
                }         
              </BlockContainer>
            </BlurContainer>          
            <Row>
              <Col lg={24} md={0} sm={0} xs={0}>
                <HorizontalDivider />
              </Col>
              <Col lg={0} md={24} sm={24} xs={24}>
                <HorizontalDivider className="blurify" />
              </Col>
            </Row>
            <BlockContainer>
            <Row className="DisplayPflex mb3">
              <Col lg={12} md={12} sm={24} xs={24}>
                <DisplayFlex>
                  <ProfileSectionHeading className="pb0">                  
                    <ContentMessage type={[Types.SUB_HEADING_LEGACY_OPTIONS]} page="My Profile" property="field_type_3_title" defaultMessage="Account Information" setTitle={this.setAcctInfoTitle} />
                  </ProfileSectionHeading>
                  {this.props.toUpdate && (geminiUser || !isAdminUser) ? (
                    <>
                    <div className="ml2">
                      <CapsuleButton
                        text="Edit"
                        whiteBackground={false}
                        iconType="edit"
                        disabled={profileData.accountInformations ? (profileData.accountInformations.length === 1 ? true : false) : ""}
                        onClick={this.viewComponent}
                      />
                    </div>
                    { geminiUser && 
                      <div className="ml2">
                        <CSREditButtonComponent
                          buttonName="CSR Edit"
                          clicked={()=> this.viewComponentByCSRUser(true)}
                          disabled= {profileData.accountInformations?(profileData.accountInformations.length===1?true:false):""}
                        />
                      </div>
                    }
                  </>
                  ) : (
                    ""
                  )}
                </DisplayFlex>  
              </Col>
              {
                this.props.toUpdate && 
                <Col lg={12} md={12} sm={24} xs={24}>
                  <div className='right-align'>
                    <StyleLessButton onClick={()=>this.exportAccountsTable()} data-test="myProfileExportIcon">
                      <IconPadding> 
                        <img src={exportIcon} alt="Export ico"/>
                        <PrintText>EXPORT</PrintText>
                      </IconPadding>
                    </StyleLessButton>
                  </div>
                </Col>
              }
            </Row>            
              {this.props.toUpdate ? (
                <Row>
                  <Col lg={24} md={0} sm={0} xs={0}>
                    <HorizontalDivider className="noMargin" />                  
                    <React.Suspense fallback={ <Preloader/> }>
                      <TableComponent 
                        eventaction={this.getAcctInfoTitle.bind(this)} 
                        analyticsTracking={this.analyticsTracking.bind(this)} 
                        TableData={profileData.accountInformations} 
                        countries={this.props.countries} 
                        exportAccountInfoDetails={this.exportAccountInfoDetails.bind(this)} />
                    </React.Suspense>          
                  </Col>
                  <Col lg={0} md={24} sm={24} xs={24}>  
                    <React.Suspense fallback={ <Preloader/> }>                
                      <CardComponent 
                        eventaction={this.getAcctInfoTitle.bind(this)} 
                        analyticsTracking={this.analyticsTracking.bind(this)} 
                        CardData={profileData.accountInformations}  
                        countries={this.props.countries} />
                    </React.Suspense>               
                  </Col>
                </Row>
              ) : (
                <Row>
                  <Col lg={24} md={0} sm={0} xs={0}>
                    <HorizontalDivider className="noMargin" />
                    <RadioTableComponent
                      eventaction={this.getAcctInfoTitle.bind(this)}
                      analyticsTracking={this.analyticsTracking.bind(this)}                      
                      RadioTableData={profileData.accountInformations}
                      toggleisEnabled={() => this.toggleisEnabled(true)}
                      fromCsrUser={this.state.fromCsrUser}
                    />
                  </Col>
                  <Col lg={0} md={24} sm={24} xs={24}>
                    <RadioCardComponent
                      eventaction={this.getAcctInfoTitle.bind(this)}
                      analyticsTracking={this.analyticsTracking.bind(this)}                                         
                      RadioCardData={profileData.accountInformations}
                      toggleisEnabled={() => this.toggleisEnabled(true)}
                      fromCsrUser={this.state.fromCsrUser}
                    />
                  </Col>
                </Row>
              )}
            </BlockContainer>
          </FixedWidth>        
        </div>
      </ContentProvider>
    );
  }
}

const mapStateToProps = state => ({
  profileData: state.getIn(["myAccount", "profileData", "data"]),
  ...myProfileDerivedStates(state.toJS())
});

export const mapDispatchToProps = dispatch => ({
  myProfileData: data => dispatch(myProfileDataSuccess(data)),
  showComponent: () => dispatch(showComponent()),
  hideComponent:()=>dispatch(hideComponent()),
  selectHeader: data => dispatch(selectHeader(data))
});


 MyProfile.propTypes = {
  accessKeyData: PropTypes.any,
  accessKeyExpiry: PropTypes.any,
  countries: PropTypes.arrayOf(PropTypes.shape({
    desc: PropTypes.string,
    value: PropTypes.string
  })),
  hideComponent: PropTypes.func,
  isLoadingProfile: PropTypes.any,
  myProfileData: PropTypes.func,

  profileData: PropTypes.shape({
    accountInformations: PropTypes.array,

    profileSummary: PropTypes.shape({
      email: PropTypes.array
    }),

    randIdentifier: PropTypes.string,

    webAccess: PropTypes.shape({
      id: PropTypes.number,
      webRegistered: PropTypes.bool
    })
  }),

  showComponent: PropTypes.func,
  toUpdate: PropTypes.bool
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(MyProfile)
);
